import {
  Container,
  Divider,
  Fab,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import HeaderLogo from "../../components/header-logo/HeaderLogo";
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import AddIcon from "@material-ui/icons/Add";
import DialogBox from "../../components/dialog-box/DialogBox";
import { StyledInput } from "../../components/styled-input/StyledInput";
import * as DataService from "../../firebase/DataService";
import { Link, Redirect } from "react-router-dom";
import { setProjects } from "../../store/slices/UserSlice";

const useStyles = makeStyles(() => ({
  root: {
    height: "100vh",
    background: "linear-gradient(to right, #243B55, #141E30)",
    padding: 0,
    paddingTop: "5rem",
    fontFamily: "Work Sans",
    color: "#fff",
  },
  authCard: {
    background: "rgb(255 255 255,  0)",
    WebkitBackdropFilter: "saturate(180%) blur(20px)",
    borderRadius: "1rem",
  },
  authCardTitle: {
    background: "#2196f345",
    color: "#fff",
    padding: "2rem",
    borderRadius: "1rem",
  },
  text: {
    fontFamily: "Poppins",
  },
  signInBtn: {
    marginTop: "1rem",
    padding: "1rem",
  },
  projectsContainer: {
    background: "rgba(0,0,0,0.5)",
    WebkitBackdropFilter: "saturate(180%) blur(20px)",
    backdropFilter: "saturate(180%) blur(20px)",
    borderRadius: "1rem",
  },
  projects: {
    height: "162px",
    width: "60%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "1rem",
  },
  fab: {
    background: "linear-gradient(to top, #0072ff, #00c6ff)",
    boxShadow: "none",
  },
}));

const Content = (props) => {
  return (
    <StyledInput
      name={"das"}
      placeholder={"Enter project name"}
      variant="filled"
      fullWidth
      onChange={props.handleChange}
    />
  );
};

const Dashboard = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);
  const app = useSelector((state) => state.app);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [projectName, setProjectName] = React.useState("");

  const closeDialogBox = () => {
    setOpenDialog(false);
  };

  const openDialogBox = () => {
    setOpenDialog(true);
  };

  const publishProject = async () => {
    const projectData = { name: projectName, id: app.id };
    await DataService.pushDataToCollection(
      "projects",
      projectData,
      localStorage.getItem("token")
    );
    dispatch(setProjects(projectData));
    closeDialogBox();
  };

  const handleChange = (e) => {
    setProjectName(e.target.value);
  };

  if (localStorage.getItem("token") === null || user.userData === {})
    return <Redirect to={"/auth"} />;

  return (
    <>
      <DialogBox
        handleClose={closeDialogBox}
        title={"Enter project name"}
        open={openDialog}
        save={publishProject}
        content={<Content handleChange={handleChange} />}
      />
      <HeaderLogo />
      <Container className={classes.root} maxWidth="xl">
        <Container maxWidth="lg">
          <h2 className={classes.text}>Hello, {user.name}!</h2>
          <h5 className={classes.text}>
            Start a new project or continue with an old one.
          </h5>
          <div className={`mt-5 p-4 ${classes.projectsContainer}`}>
            <h2> Projects</h2>
            <Grid container className={"mt-5"}>
              <Grid item xs={12} md={3} lg={3}>
                <div
                  className={classes.projects}
                  style={
                    user.projects !== ""
                      ? { border: "1px solid #bfbfbf" }
                      : { border: "1px dashed #bfbfbf" }
                  }
                >
                  {user.projects !== "" ? (
                    <div>
                      <div>
                        <h4 style={{ wordBreak: "break-word" }}>
                          {user.projects.name}
                        </h4>
                      </div>
                      <Link to={"/visualizer"}>Start</Link>
                    </div>
                  ) : (
                    <Fab
                      size="small"
                      color="secondary"
                      aria-label="add"
                      onClick={openDialogBox}
                      className={classes.fab}
                    >
                      <AddIcon />
                    </Fab>
                  )}
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </Container>
    </>
  );
};

export default Dashboard;
